import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Card, Button, Input, Select, Field, Stat, Textarea } from "@/components/UI";
import PriceUpdateModal from "@/components/PriceUpdateModal";
import { Plus, PencilSimple, Trash, Pill, ChartLine, Package as PackageIcon, ListChecks, Warning, Drop, TrendUp, CurrencyCircleDollar, ShoppingCart, Archive, ArrowCounterClockwise, UploadSimple, X, ArrowRight } from "@phosphor-icons/react";
import { toast } from "sonner";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import { USAGE_UNITS, CATEGORIES, EMPTY, DOSE_UNITS_FOR, expiryBadge, EMPTY_BULL, EMPTY_PROTOCOL, muid } from "./constants";

export function MedUsage() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/medicine-usage").then(r => setItems(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <div className="mb-4 text-xs bg-[#E4EEE6] border border-[#c2d6c8] text-[#2D4A36] px-3 py-2 rounded-md">
        ℹ️ Kullanım kayıtları <b>otomatik</b> oluşturulur. Veteriner → Tedavi kısmında ilaç ve kullanılan miktar girildiğinde stoktan otomatik düşer, kayıt burada listelenir.
      </div>
      <Card className="!p-0 overflow-hidden">
        <table className="data-table" data-testid="usage-history-table">
          <thead><tr><th>Tarih</th><th>İlaç</th><th className="text-right">Miktar</th><th className="text-right">Maliyet</th><th>Amaç</th><th>Hayvan</th><th>Kaynak</th><th>Notlar</th></tr></thead>
          <tbody>
            {items.map(x => (
              <tr key={x.id}>
                <td className="tabnum">{x.date}</td>
                <td className="font-semibold">{x.medicine_name}</td>
                <td className="text-right tabnum">{x.amount} {x.usage_unit}</td>
                <td className="text-right tabnum font-semibold text-[#C45B45]">{Number(x.cost).toLocaleString("tr-TR")} ₺</td>
                <td>
                  <span className="inline-block px-2 py-0.5 rounded-full text-xs font-medium"
                    style={{ background: x.purpose === "tedavi" ? "#FBE9E4" : "#EEECE5", color: x.purpose === "tedavi" ? "#C45B45" : "#1A1D1A" }}>
                    {x.purpose}
                  </span>
                </td>
                <td className="capitalize text-sm">{x.animal_type || "—"}</td>
                <td className="text-xs text-[#5e675e]">{x.treatment_id ? "Tedavi" : "Manuel"}</td>
                <td className="text-sm text-[#5e675e]">{x.notes || "—"}</td>
              </tr>
            ))}
            {!items.length && (
              <tr><td colSpan={8} className="text-center py-10 text-[#8a938c]">
                Henüz kullanım kaydı yok. Veteriner → Tedavi sekmesinden ilaç + miktar girerek başlayın.
              </td></tr>
            )}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
